export const CATEGORIES = {
  alert: 'bullhorn',
  checklist: 'check-circle',
  connections: 'users',
  earnings: 'dollar-sign',
  referral: 'dollar-sign',
  referred: 'dollar-sign',
  recommendation: 'star',
  reminder: 'calendar-check',
  unlocked: 'lock-open-alt',
  CAMPUS_VISIT: 'dollar-sign',
  file: 'file-alt',
};
